let currentMainIndex = 0;

function selectMainMenu(index) {
  currentMainIndex = index;

  const allBtns = document.querySelectorAll('.main-menu-btn');
  const selectedBtn = allBtns[index];
  const selectedTitle = selectedBtn?.dataset.title?.trim();
  const selectedUrl = selectedBtn?.dataset.url;

  // Toggle active state
  allBtns.forEach((btn, i) => {
    btn.classList.toggle('active', i === index);
  });

  // Hide all submenu wrappers and mega menus first
  document.querySelectorAll('.submenu-wrapper').forEach(wrapper => wrapper.style.display = 'none');
  document.querySelectorAll('.mobile-mega-menu').forEach(menu => menu.style.display = 'none');

  const isAllMenu = selectedTitle === 'All';

  if (isAllMenu) {
    // Show the "All" special menu
    document.querySelector('.submenu-content-wrapper')?.classList.add('hidden');
    const megaMenu = document.querySelector(`.mobile-mega-menu[data-index="${index}"]`);
    if (megaMenu) megaMenu.style.display = 'block';
    return;
  }

  // Get the corresponding submenu wrapper
  const wrapper = document.querySelector(`.submenu-wrapper[data-menu-index="${index}"]`);
  const hasSubmenu = wrapper && wrapper.querySelectorAll('.submenu-btn').length > 0;

  if (hasSubmenu) {
    // Show submenu
    document.querySelector('.submenu-content-wrapper')?.classList.remove('hidden');
    wrapper.style.display = 'flex';
    selectSubMenu(index, 0);
  } else {
    // No submenu: redirect to the page
    if (selectedUrl) {
      window.location.href = selectedUrl;
    }
  }
}

function selectSubMenu(mainIndex, subIndex) {
  const btns = document.querySelectorAll(`.submenu-wrapper[data-menu-index="${mainIndex}"] .submenu-btn`);
  btns.forEach((btn, i) => btn.classList.toggle('active', i === subIndex));

  document.querySelectorAll(`.submenu-content-item[data-menu-index="${mainIndex}"]`).forEach(item => {
    item.style.display = 'none';
  });

  const content = document.querySelector(`.submenu-content-item[data-menu-index="${mainIndex}"][data-submenu-index="${subIndex}"]`);
  if (content) content.style.display = 'block';
}

document.addEventListener("DOMContentLoaded", function () {
  selectMainMenu(0);
});
